import React, { useEffect, useRef, useState } from 'react';
import QRCode from "react-qr-code";
import barcode from '../../images/barcode.png';
// import JsBarcode from 'jsbarcode';
import { VscClose } from 'react-icons/vsc';
import iconDownload from '../../images/icon-download.svg';
import axios from "axios";
import * as securityHelper from "../../helper/SecurityHelper";
import * as htmlToImage from "html-to-image";

export default function PassCard({ setPassCard }: any) {

  const [cmpnyNm, setCmpnyNm] = useState('');
  const [userNm, setUserNm] = useState('');
  const [entrncDt, setEntrncDt] = useState('');
  const [entrncTime, setEntrncTime] = useState('');
  const [qrcodeValue, setQrcodeValue] = useState('');
  const [barcodeImg, setBarcodeImg] = useState('');
  const modalRef = useRef<HTMLDivElement>(null);
  const user = securityHelper.getLoginUser();

  useEffect(() => {
    const user = securityHelper.getLoginUser();
    setCmpnyNm(user.companyName);
    setUserNm(user.name);
    const userSeq = user.seq;
    fn_retrieveTbmEntrncTime(userSeq);
    setQrcodeValue(user.seq + user.companySeq)
    // setQrcodeValue(user.accessHost + "/sign/valid-check?key=" + user.encodedUserId)

    const canvas = document.createElement('canvas');
    // JsBarcode(canvas, qrcodeValue, { width: 3, height: 40, displayValue: false, margin: 0 });
    setBarcodeImg(canvas.toDataURL('image/png'))
  }, [])

  const fn_retrieveTbmEntrncTime = async (userSeq: bigint) => {
    if (user.auth === 'KOX' || user.auth === 'COM') {
      const rtrnData = await axios.post('admin/api/tbm/retrieveTbmWrkTimeKoxCom', { userSeq: userSeq });
      setEntrncDt(rtrnData.data.workDt);
      setEntrncTime(rtrnData.data.workStrtTime);
      // entrnDt, Time 저장하기
    } else {
      const rtrnData = await axios.post('admin/api/tbm/retrieveTbmWrkTime', { userSeq: userSeq });
      rtrnData.data.map((data: any, i:number) => {
        if (i === 0) {
          setEntrncDt(data.workDt);
          setEntrncTime(data.workStrtTime);
        }
      })
    }
  }

  const downloadHandler = () => {
    var node = document.getElementById('passCard_printDiv');
    // @ts-ignore
    htmlToImage.toPng(node)
      .then(function (dataUrl) {
        //console.log(dataUrl)
        var link = document.createElement("a");
        link.download = "출입증.png";
        link.href = dataUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });

  };

  useEffect(() => {
    // 이벤트 핸들러 함수
    const handler = (e: any) => {
      // mousedown 이벤트가 발생한 영역이 모달창이 아닐 때, 모달창 제거 처리
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setPassCard(false);
      }
    };
    // 이벤트 핸들러 등록
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler); // 모바일 대응
    return () => {
      // 이벤트 핸들러 해제
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler); // 모바일 대응
    };
  });
  return (
    <div className='w-full h-full absolute flex justify-center items-center bg-black bg-opacity-[70%] z-[1000]' ref={modalRef}>
      <div
          className='w-[308px] md:w-[750px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center pb-[45px] md:pb-[90px]'>
        <div
            className='w-full h-44 md:h-[110px] bg-[#F4F4F4] text-txtBlack flex justify-between items-center rounded-t-[5px] md:rounded-t-[12px]'>
          <p className='ml-20 text-15 md:ml-60 md:text-45 font-preBold'>출입증</p>
          <VscClose onClick={() => setPassCard(false)}
                    className='hover:cursor-pointer mr-15 text-22 md:mr-45 md:text-66'/>
        </div>
        <div id="passCard_printDiv"
             className='pl-[30px] pr-[30px] pt-33 pb-22 md:w-[650px] md:pl-[75px] md:pr-[75px] md:pt-[82px] md:pb-[55px] bg-white'>
          <div
              className='h-139 md:h-[347px] bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] relative'>
            {/* 날짜별 div 배경 색깔 바꾸기 */}
            <p className='absolute text-15 md:text-37 font-preBold top-18 left-18 md:top-45 md:left-45'>{cmpnyNm}</p>
            <p className='absolute text-20 md:text-50 font-preBold top-42 left-18 md:top-105 md:left-45'>{userNm}</p>
            {/*<img className='absolute top-80 left-30' src={barcodeImg} />*/}
            <img src={barcode} className='absolute top-76 left-25 w-150 h-50'/>
            {/*<img className='absolute w-185 md:w-[462px] right-0 bottom-0' src={logoCoex} alt='logo'/>*/}
          </div>
          <p className='mt-25 md:mt-62 font-preBold text-16 md:text-40 text-[#868686]'>{entrncTime}</p>
          <p className='font-preBold text-23 md:text-57 text-txtBlack'>{entrncDt}</p>
          <p className='mt-18 md:mt-45 text-center tracking-tight font-preLight text-14 md:text-33 leading-[17px] md:leading-[40px] text-[#B1B1B1] whitespace-pre-line'>본
            출입증을 보안관리자에게 제시하여{'\n'}출입하여 주세요.</p>
        </div>
        <div onClick={downloadHandler}
             className='hover:cursor-pointer w-[60%] h-38 md:w-[312px] md:h-95 flex justify-center items-center bg-white border border-point text-point text-14 rounded-[5px] md:text-35 md:rounded-[12px]'>
          <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconDownload} alt='download'/>
          <p>이미지 저장</p>
        </div>
        <button onClick={() => setPassCard(false)}
                className='font-preBold text-15 md:text-37 text-white w-125 md:w-[312px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-20 py-7 md:py-[18px]'>확인
        </button>
      </div>
    </div>
  );
}

